module.exports = __webpack_public_path__ + "static/img/图片2.57da26a2.png";